import PropTypes from "prop-types";
import MarketplaceDonutChart from "./charts/MarketplaceDonutChart";
import { useNavigate, useParams } from "react-router-dom";

function MarketplaceHealthCard({ free, claimed, premium }) {
  const navigate = useNavigate();
  const { email, locationId } = useParams();

  const handleRoutes = (page) => {
    const newIframeUrl = `/${email}/${locationId}/${page}`;
    navigate(newIframeUrl);
  };
  return (
    <section className="sd-card">
      <h3 className="sd-section-title">Marketplace Health</h3>
      <div className="sd-marketplace">
        <MarketplaceDonutChart values={[free + premium, free, premium]} />
        <div className="sd-marketplace__meta">
          <div className="sd-key-value">
            <span>New Listings (mo)</span>
            <strong>{free + premium}</strong>
          </div>
          <div className="sd-key-value">
            <span>Free Listings (mo)</span>
            <strong>{free}</strong>
          </div>
          <div className="sd-key-value">
            <span>Premium Listings (mo)</span>
            <strong>{premium}</strong>
          </div>
          <button type="button" className="sd-outline-btn" onClick={() => handleRoutes("accounts")}>
            View Listings
          </button>
        </div>
      </div>
      <div className="sd-legend">
        <span>
          <i style={{ background: "#8ea2ff" }} />
          New Listings
        </span>
        <span>
          <i style={{ background: "#49bdd1" }} />
          Free
        </span>
        <span>
          <i style={{ background: "#a862de" }} />
          Premium
        </span>
      </div>
    </section>
  );
}

MarketplaceHealthCard.propTypes = {
  free: PropTypes.number.isRequired,
  claimed: PropTypes.number.isRequired,
  premium: PropTypes.number.isRequired,
};

export default MarketplaceHealthCard;
